module.exports = __webpack_public_path__ + "fonts/Rubik-Medium.f32428d.woff";